module.exports = __webpack_public_path__ + "img/white.7e3d9a42.webp";